import { Box } from '@mui/material';
import React from 'react';
import InsightsList from '../components/Insights/InsightsList';
import TagFilter from '../components/Insights/TagFilter';

const InsightsListPage: React.FC = () => {
  return (
    <Box>
      <TagFilter />
      <InsightsList />
    </Box>
  );
};

export default InsightsListPage;
